export default function ProductDropdown({ name, value, changesField }) {
  const is_included = changesField?.length > 0 ? 'red-input' : '';

  return (
    <select
      className={`form-control form-control-sm text-dark ${is_included}`}
      name={name}
      style={{ marginTop: '6px' }}
      readOnly
    >
      <option disabled selected>
        {value}
      </option>
    </select>
  );
}
